import React from "react";

const ProgrammeBreakdown = ({ programmeData }) => (
    <section className="card">
        <h3>Programme Breakdown</h3>
        <table>
            <thead>
                <tr>
                    <th>Code</th>
                    <th>Programme</th>
                    <th>Budget</th>
                    <th>Spent</th>
                </tr>
            </thead>
            <tbody>
                {programmeData.map((row, i) => (
                    <tr key={i}>
                        <td>{row.code}</td>
                        <td>{row.name}</td>
                        <td>{row.budget.toLocaleString()}</td>
                        <td>{row.spent.toLocaleString()}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </section>
);

export default ProgrammeBreakdown;